module.exports = __webpack_public_path__ + "img/verifikasi-web-icon-1.47937ab2.svg";